var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDoc = function SvgDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.109.546C0 .76 0 1.04 0 1.6v16.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C.76 20 1.04 20 1.6 20h12.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C16 19.24 16 18.96 16 18.4V1.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C15.24 0 14.96 0 14.4 0H1.6C1.04 0 .76 0 .546.109a1 1 0 0 0-.437.437zM4 13h3a1 1 0 1 1 0 2H4a1 1 0 1 1 0-2zm-1-3a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4a1 1 0 0 1-1-1zm1-5h8a1 1 0 1 1 0 2H4a1 1 0 0 1 0-2z"
  })));
};
export default SvgDoc;